/**
 * @generated SignedSource<<b011930dee4e042316b58b678128ec71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContractRequestStatusEnum = "completed" | "pending" | "rejected" | "started";
export type JobApplicationStatus = "deleted" | "freelancer_not_interested" | "hired" | "interview" | "job_application_draft" | "job_application_invited" | "job_application_sent" | "job_viewed" | "offer" | "potential" | "rejected" | "screening_completed" | "screening_rejected" | "screening_requested" | "screening_started";
export type VideoStatusEnum = "pending" | "processed" | "processing" | "processing_failed" | "processing_queued" | "processing_rejected" | "unprocessed";
export type VideoTypeEnum = "answer" | "blog_post" | "company" | "profile";
export type CreateVideoInput = {
  blogPostId?: string | null | undefined;
  blogPostRawId?: number | null | undefined;
  clientMutationId?: string | null | undefined;
  extension: string;
  firmId?: string | null | undefined;
  firmRawId?: number | null | undefined;
  public?: boolean | null | undefined;
  questionId?: string | null | undefined;
  questionRawId?: number | null | undefined;
  videoType?: VideoTypeEnum | null | undefined;
};
export type video_CreateVideoMutation$variables = {
  input: CreateVideoInput;
};
export type video_CreateVideoMutation$data = {
  readonly createVideo: {
    readonly uploadUrl: string | null | undefined;
    readonly video: {
      readonly contractRequests: ReadonlyArray<{
        readonly jobApplication: {
          readonly status: JobApplicationStatus;
        } | null | undefined;
        readonly status: ContractRequestStatusEnum | null | undefined;
      }> | null | undefined;
      readonly id: string;
      readonly question: {
        readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_Question" | "ScreeningQuestionStep_Question">;
      } | null | undefined;
      readonly status: VideoStatusEnum;
      readonly user: {
        readonly video: {
          readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_Video" | "ScreeningQuestionStep_Video">;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"ScreeningQuestionStep_User">;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ScreeningQuestionStep_Video">;
    } | null | undefined;
  } | null | undefined;
};
export type video_CreateVideoMutation = {
  response: video_CreateVideoMutation$data;
  variables: video_CreateVideoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ScreeningQuestionStep_Video"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectReason",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optimizedUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "posterUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableSubtitles",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Video",
  "kind": "LinkedField",
  "name": "video",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v6/*: any*/),
    (v4/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "video_CreateVideoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateVideoPayload",
        "kind": "LinkedField",
        "name": "createVideo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AnswerListItem_Question"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ScreeningQuestionStep_Question"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Video",
                    "kind": "LinkedField",
                    "name": "video",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AnswerListItem_Video"
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ScreeningQuestionStep_User"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContractRequest",
                "kind": "LinkedField",
                "name": "contractRequests",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobApplication",
                    "kind": "LinkedField",
                    "name": "jobApplication",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "video_CreateVideoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateVideoPayload",
        "kind": "LinkedField",
        "name": "createVideo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rawId",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Answer",
                    "kind": "LinkedField",
                    "name": "textualAnswer",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "textualAnswer",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Answer",
                    "kind": "LinkedField",
                    "name": "videoAnswer",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "videoMaxDuration",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "videoMinDuration",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContractRequest",
                "kind": "LinkedField",
                "name": "contractRequests",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobApplication",
                    "kind": "LinkedField",
                    "name": "jobApplication",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d1f279a232286ec7801e03029d7ca12c",
    "id": null,
    "metadata": {},
    "name": "video_CreateVideoMutation",
    "operationKind": "mutation",
    "text": "mutation video_CreateVideoMutation(\n  $input: CreateVideoInput!\n) {\n  createVideo(input: $input) {\n    uploadUrl\n    video {\n      id\n      status\n      question {\n        ...AnswerListItem_Question\n        ...ScreeningQuestionStep_Question\n        id\n      }\n      user {\n        video {\n          ...AnswerListItem_Video\n          ...ScreeningQuestionStep_Video\n          id\n        }\n        ...ScreeningQuestionStep_User\n        id\n      }\n      contractRequests {\n        status\n        jobApplication {\n          status\n          id\n        }\n        id\n      }\n      ...ScreeningQuestionStep_Video\n    }\n  }\n}\n\nfragment AnswerListItemStatus_Video on Video {\n  id\n  status\n  rejectReason\n}\n\nfragment AnswerListItem_Question on Question {\n  rawId\n  id\n  title\n  textualAnswer {\n    id\n    textualAnswer\n  }\n  videoAnswer {\n    video {\n      ...AnswerListItem_Video\n      id\n    }\n    id\n  }\n}\n\nfragment AnswerListItem_Video on Video {\n  id\n  url\n  ...AnswerListItemStatus_Video\n}\n\nfragment ScreeningQuestionStepStatusListItem_Video on Video {\n  id\n  status\n  rejectReason\n}\n\nfragment ScreeningQuestionStep_Question on Question {\n  rawId\n  id\n  title\n  textualAnswer {\n    id\n    textualAnswer\n  }\n  videoAnswer {\n    video {\n      ...ScreeningQuestionStep_Video\n      id\n    }\n    id\n  }\n}\n\nfragment ScreeningQuestionStep_User on User {\n  configuration {\n    videoMaxDuration\n    videoMinDuration\n  }\n  video {\n    ...ScreeningQuestionStep_Video\n    id\n  }\n}\n\nfragment ScreeningQuestionStep_Video on Video {\n  id\n  url\n  status\n  ...Video_Video\n  ...ScreeningQuestionStepStatusListItem_Video\n}\n\nfragment Video_Video on Video {\n  id\n  url\n  optimizedUrl\n  posterUrl\n  enableSubtitles\n}\n"
  }
};
})();

(node as any).hash = "04659a4cad2aa7a1f29bb778502dcf91";

export default node;
